// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes timer-pulse-2e3a79fd{0%{box-shadow:0 0 0 0 rgba(122,204,51,.6)}70%{box-shadow:0 0 0 10px rgba(204,169,44,0)}to{box-shadow:0 0 0 0 rgba(204,169,44,0)}}.card-footer[data-v-2e3a79fd]{border-bottom-left-radius:1px;border-bottom-right-radius:1px;border-top:none;padding:8px 0}.modal-wrapper .card-footer[data-v-2e3a79fd]{display:flex;justify-content:right;padding:0}.add-project-modal-footer .card-footer[data-v-2e3a79fd]{justify-content:flex-end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
